import { cva } from "class-variance-authority";

export const alertVariants = cva(
  [
    // Transition
    "duration-100 ease-out data-[closed]:opacity-0 data-[closed]:scale-95",

    "row-start-2 w-full rounded-2xl bg-white p-8 shadow-lg ring-1 ring-accent sm:rounded-2xl sm:p-6 dark:bg-zinc-900 forced-colors:outline",
  ],
  {
    variants: {
      size: {
        xs: "sm:max-w-xs",
        sm: "sm:max-w-sm",
        md: "sm:max-w-md",
        lg: "sm:max-w-lg",
        xl: "sm:max-w-xl",
        "2xl": "sm:max-w-2xl",
        "3xl": "sm:max-w-3xl",
        "4xl": "sm:max-w-4xl",
        "5xl": "sm:max-w-5xl",
      },
    },
  },
);
